function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import moment from "moment-timezone";
import "moment/min/locales";
import { postUserLanguagePreferences } from "../actions";
export var LanguagesContext = /*#__PURE__*/React.createContext({});
export var LanguagesProvider = function LanguagesProvider(_ref) {
  var children = _ref.children;
  // workaround to avoid blank page while loading resources
  var _useTranslation = useTranslation(["afipActivity", "bankAccountType", "campaign", "country", "documentType", "entityType", "gender", "goalType", "evaluationFactor", "evaluationFactorCategory", "incomeSource", "incomeType", "industry", "investmentItemType", "investmentPlan", "ivaTaxpayerType", "language", "maritalStatus", "market", "operationState", "sentimentType", "timeZone", "translation", "workingStatus"]),
    i18n = _useTranslation.i18n;
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUser = useSelector(function (state) {
    return state.entities.users.byId[authUserId];
  });
  var postUserCall = useSelector(function (state) {
    return state.apiCalls.postUser["undefined"];
  }) || {};
  var _useCookies = useCookies(["pref-languages"]),
    _useCookies2 = _slicedToArray(_useCookies, 3),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1],
    removeCookie = _useCookies2[2];
  var _useState = useState(authUser && authUser.languagePreferences || cookies["pref-languages"] || [{
      language: {
        code: i18n.resolvedLanguage
      },
      user: {
        id: authUserId
      },
      appDefault: true
    }]),
    _useState2 = _slicedToArray(_useState, 2),
    languagePreferences = _useState2[0],
    setLanguagePreferences = _useState2[1];
  function resolveLanguagePreference() {
    return languagePreferences.find(function (lngPrf) {
      return lngPrf.appDefault;
    });
  }
  function containsLanguagePreference(languageCode) {
    return languagePreferences.find(function (lngPrf) {
      var code1 = lngPrf.language.code.substring(0, 2);
      var code2 = languageCode.substring(0, 2);
      return code1 === code2;
    }) !== undefined;
  }
  useEffect(function () {
    removeCookie("pref-languages");
    setCookie("pref-languages", languagePreferences);
    var resolvedLanguagePreference = resolveLanguagePreference();
    i18n.changeLanguage(resolvedLanguagePreference.language.code);
    moment.locale(resolvedLanguagePreference.language.code);
    if (authUser && JSON.stringify(authUser.languagePreferences) !== JSON.stringify(languagePreferences)) {
      dispatch(postUserLanguagePreferences(authUser, languagePreferences));
    }
  }, [languagePreferences]);
  useEffect(function () {
    // uncomment to clean cookies
    removeCookie("pref-languages");
    if (!authUser) return;
    if (authUser.languagePreferences.length === 0) {
      var toPost = Object.create(null);
      toPost.languageCode = i18n.language;
      toPost.userId = authUserId;
      toPost.appDefault = true;
      dispatch(postUserLanguagePreferences(authUser, [toPost]));
    } else {
      setLanguagePreferences(authUser.languagePreferences);
    }
  }, [authUser]);
  return /*#__PURE__*/React.createElement(LanguagesContext.Provider, {
    value: {
      resolvedLanguagePreference: resolveLanguagePreference(),
      containsLanguagePreference: containsLanguagePreference,
      languagePreferences: languagePreferences,
      setLanguagePreferences: setLanguagePreferences,
      loading: postUserCall.isFetching
    }
  }, children);
};
export var useLanguagesContext = function useLanguagesContext() {
  return useContext(LanguagesContext);
};